import React from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import { Colors } from "baseStyles/enums/colors";
import { ChildWithImage } from "./childWithImage";
import Button from "schoolUiComponents/basic/Button";
import MergeStudentStyles from "./styles";
import { APIS } from "../api";
import { interactedAddreplaceStudentProfileScreenEvent, ptlLinkingAttemptedEvent } from "../events";
import { IChild, IReferralData } from ".";
import StringUtility from "utility/string";


export const NewChild = ({ newChild, setShowSuccessPopup, showReplaceChild, existingChild, setOptionSelected, referralData }: { newChild: IChild, setShowSuccessPopup: React.Dispatch<React.SetStateAction<boolean>>, showReplaceChild: boolean, existingChild: IChild[], setOptionSelected: React.Dispatch<React.SetStateAction<string>>, referralData : IReferralData }) => {
    const styles = MergeStudentStyles();

    return (
        <FlexBox column padding={24} borderRadius={24} backgroundColor={Colors.WHITE_2} gap={24} {...styles.newChild}>
            <FlexBox column gap={8} fullWidth>
                {showReplaceChild ? <Text.H3 color={Colors.BLACK} emphasis>Link as a new profile</Text.H3>
                 : <Text.H3 color={Colors.BLACK} lines={3} fullWidth emphasis center>Link {StringUtility.formatFullName(newChild.first_name, newChild.last_name)} to your parent account</Text.H3>}
                <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY}>Already linked student profiles will stay intact.</Text.SMALL>
            </FlexBox>
            <ChildWithImage child={newChild} />
            <Button.M onClick={() => {
                const queryParams = new URLSearchParams(window.location.search);
                const referral_type = queryParams.get("referral_type");
                const referrer_code = queryParams.get("referrer_code");
                const tr_sub_source = queryParams.get("tr_sub_source");
                const trd_id = queryParams.get("trd_id");
                interactedAddreplaceStudentProfileScreenEvent({ clickedOn: "Link as new profile", linkedStudentCount: existingChild.length.toString(), grade: newChild.grade_code, ...referralData });
                ptlLinkingAttemptedEvent({ linkedStudentCount: existingChild.length.toString(), optionsSelected: ["Link as new profile"], grade: newChild.grade_code, ...referralData })
                setOptionSelected("Link as new profile");
                APIS.linkStudent({ student_id: newChild?.id, referral_type, referrer_code, tr_sub_source, trd_id }).then((res) => {
                    setShowSuccessPopup(true);
                    setTimeout(() => {
                        // [AI GENERATED CODE] Post-login student link — tag session with parent_signin
                        if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('parent_signin');
                        window.location.href = res?.data?.redirect_url || '/parent-dashboard';
                    }, 3000)
                }).catch((err) => {
                    showFlashMessage(err?.response?.data?.error || "Something went wrong!", "error");
                })
            }} primary><Text.H4 color={Colors.WHITE}>Link as new profile</Text.H4></Button.M>
        </FlexBox>
    )
}